// import Axios from "axios"

export function isAuthenticated(){
    return localStorage.getItem('X-Access-Token') && localStorage.getItem('X-Access-Expire') > Date.now()
}